import { post, get } from "./axios";

//获取航班详情
export function flightDetail(data) {
  return post(`/parse-plan/getRouteInformation`,data);
}

//航班颠簸情况统计
export function flightBump(data){
  return post(`/parse-route-info/range/bump`,data);
}

//获取早出港航班（8点到10点颠簸时间统计）
export function listOfDaysMorUrl(data){
  return get(`/parse-route-info/listOfDaysMor`,data);
}

//查询近几日颠簸统计数据
export function bumpListOfDays(data){
  return get(`/parse-route-info/listOfDays`,data);
}
//查询昨天飞行颠簸占比统计
export function listOfPercentage(data){
  return get(`/parse-route-info/listOfPercentage`,data);
}


// WEBPACK FOOTER //
// ./src/api/bump.js